import * as types from './types';

export const refreshCategories = () => ({
  type: types.REFRESH_CATEGORIES
});
